import React from 'react';
import { Box, Card, Radio, Typography } from '@mui/material';
import moment from 'moment/moment';
import 'moment/locale/es';
import { Comment, ReplyComment } from '../comment-types';
import { CommentFilter } from './CommentFilter';
import { CommentSearchStatus } from './CommentSearchStatus';
import { CommentPostUrl } from './CommentPostUrl';

moment.locale('es');

type CommentItemProps = {
  comment: Comment | ReplyComment;
  onRefetch: () => void;
  onSelectOrUnselect: () => void;
  selected: boolean;
  search?: string;
};
export const CommentSearchItem: React.FC<CommentItemProps> = ({
  comment,
  onRefetch,
  onSelectOrUnselect,
  selected,
  search,
}) => {
  //const classes = useStyles();
  const { user } = comment;

  return (
    <Card
      style={{
        padding: '10px 10px',
        border: selected ? '1px solid #ff6d00' : 'none',
      }}
    >
      <Box display={'flex'} alignItems={'center'}>
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Radio
            checked={selected}
            //onChange={onSelectOrUnselect}
            onClick={onSelectOrUnselect}
            name="radio-buttons"
            inputProps={{ 'aria-label': 'A' }}
          />
        </Box>
        <Box flex={1} paddingLeft={1}>
          <Box
            display={{ xs: 'block', sm: 'flex' }}
            justifyContent={'space-between'}
          >
            <Box display={'flex'} alignItems={'center'}>
              <Box sx={{ display: { sm: 'none', xs: 'block' } }}>
                <Radio
                  checked={selected}
                  //onChange={onSelectOrUnselect}
                  onClick={onSelectOrUnselect}
                  name="radio-buttons"
                  inputProps={{ 'aria-label': 'A' }}
                />
              </Box>
              <Box display={{ xs: 'block', sm: 'flex' }} alignItems={'center'}>
                <Typography
                  variant="body1"
                  fontWeight={700}
                  mr={1}
                  fontSize={14}
                >
                  {user?.name}
                </Typography>
                <Typography variant="body1" fontSize={14}>
                  {moment(comment.created_at as string).fromNow()}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent={{ xs: 'space-between', sm: 'center' }}
              alignItems="center"
            >
              <CommentSearchStatus comment={comment} />
              <CommentFilter comment={comment} onSuccess={onRefetch} />
            </Box>
          </Box>
          <div
            dangerouslySetInnerHTML={{
              __html: search
                ? (comment.message.replaceAll(
                    search,
                    `<span style="color:#FF0000">${search}</span>`,
                  ) as string)
                : comment.message,
            }}
          ></div>
          <Box sx={{paddingTop:2, cursor: 'pointer', textDecoration: 'underline', fontWeight:700}}>
            <CommentPostUrl key={comment?.id} post_id={comment?.post_id}/>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
